import { Box, Typography } from '@mui/material';
import { useGetScreenSize } from '@utils/useGetScreenSize';

export const MessageBrokerageAssigned = () => {
  const { isMobileOrSmallScreen } = useGetScreenSize();
  return (
    <Box sx={{ maxWidth: isMobileOrSmallScreen ? '300px' : '500px' }}>
      <Typography
        variant='bodySmall'
        sx={{
          fontWeight: 'bold',
          marginTop: '16px',
          marginBottom: '8px',
        }}
      >
        Sorry, another brokerage is assigned to this account.
      </Typography>
      <Typography variant='bodySmall'>
        If you believe that this is incorrect and you are the broker of record, please
        <a
          href='mailto:service@lioinsurance.com'
          style={{
            color: 'accent.tertiary',
            textDecoration: 'none',
          }}
        >
          {' '}
          contact LIO support{' '}
        </a>
        or call 1-877-546-7155 Monday through Friday between 8:30am - 8:30pm ET.
      </Typography>
    </Box>
  );
};
